<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Academy Redemption Request List<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>

          <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
        </div>
      </div>

      <div class="mainDivBody">
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
              <button (click)="loadWallet($event)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="walletlist" [autoLayout]="true" [paginator]="true" [rows]="10"
              [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadWallet($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="userNameTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="academyName">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Name <p-sortIcon
                        field="academyName"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="fullName" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="fullName"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="created_at" class="userdateTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Date <p-sortIcon field="created_at"></p-sortIcon>
                    </div>
                  </th>
                  <th class="amountTD" pSortableColumn="transferAmount">
                    <div class="p-d-flex p-jc-between p-ai-center"> Amount <p-sortIcon
                        field="transferAmount"></p-sortIcon>
                    </div>
                  </th>
                  <!-- <th class="" pSortableColumn="tds"><div class="p-d-flex p-jc-between p-ai-center"> TDS <p-sortIcon field="tds"></p-sortIcon></div></th> -->
                  <!-- <th class="CommissionTD" pSortableColumn="commission">
                      <div class="p-d-flex p-jc-between p-ai-center"> Commission <p-sortIcon field="commission"></p-sortIcon>
                      </div>
                    </th> -->
                  <th class="transferCreditTD" pSortableColumn="totalCreditedAmount">
                    <div class="p-d-flex p-jc-between p-ai-center"> Transferable Amount <p-sortIcon
                        field="totalCreditedAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bankName show-col"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> Bank Name <p-sortIcon field="bankName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="accountTD" pSortableColumn="accountNumber show-col">
                    <div class="p-d-flex p-jc-between p-ai-center"> A/c No. <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="status-Td statusTd" pSortableColumn="status"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Status <p-sortIcon field="status"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th [ngSwitch]="academyName" pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                      [value]=" dt.filters['academyName'] ? dt.filters['academyName'].value : ''" />
                  </th>

                  <th [ngSwitch]="userName" class="userNameTD p-element   text-nowrap" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                      [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" />
                  </th>
                  <th [ngSwitch]="created_at" class="userdateTD">
                    <!-- <p-calendar #pCalendarId class="p-column-filter" readonlyInput="true" inputId="calendar" dateFormat="dd-mm-yy" (onSelect)=" setDownloadFlag(); dt.filter($event, 'created_at', 'dateIs')
                            " [showIcon]="false" appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2000:2030" [(ngModel)]="createdatvalue"></p-calendar> -->
                  </th>
                  <th [ngSwitch]="transferAmount" class="amountTD p-element text-nowrap" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'transferAmount', 'contains') "
                      [value]=" dt.filters['transferAmount'] ? dt.filters['transferAmount'].value : '' " />
                  </th>
                  <!-- <th [ngSwitch]="tds"  class="p-element   text-nowrap"
                                    style="left: 0px"><input pInputText type="text" (keyup.enter)="
                              setDownloadFlag();
                              dt.filter($event.target.value, 'tds', 'contains')
                            " [value]="dt.filters['tds'] ? dt.filters['tds'].value : ''" /></th> -->
                  <!-- <th [ngSwitch]="commission" class="p-element   text-nowrap" style="left: 0px">
                      <input pInputText type="text" (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'commission', 'contains')" [value]=" dt.filters['commission'] ? dt.filters['commission'].value : '' " />
                    </th> -->
                  <th [ngSwitch]="totalCreditedAmount" class="transferCreditTD p-element   text-nowrap"
                    style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'totalCreditedAmount', 'contains') "
                      [value]=" dt.filters['totalCreditedAmount'] ? dt.filters['totalCreditedAmount'].value : '' " />
                  </th>
                  <th [ngSwitch]="bankName " class="BankDteailsTD show-col" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'bankName', 'contains')"
                      [value]=" dt.filters['bankName'] ? dt.filters['bankName'].value : ''" />
                  </th>
                  <th [ngSwitch]="accountNumber" class="accountTD show-col">
                    <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " />
                  </th>
                  <th [ngSwitch]="status" class="status-Td statusTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <p-dropdown appendTo="body" #pDropDownId [options]="statuses"
                      (onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
                      placeholder="Select Status" [showClear]="true">
                      <ng-template let-option pTemplate="item">
                        <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                      </ng-template>
                    </p-dropdown>
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <!-- <button pButton pRipple label=" Bank Details" icon="pi pi-plus"
                        [ngClass]="hide ? 'show-col p-button p-button-secondary p-button-rounded ' : 'hide-col p-button-secondary p-button-rounded'"
                        (click)="setDownloadFlag(); addColumns()"></button><button pButton pRipple label=" Hide" icon="pi pi-minus"
                        [ngClass]="hide ? 'hide-col p-button p-button-rounded' : 'show-col p-button p-button-rounded'"
                        (click)="setDownloadFlag(); removeColumns()"></button> -->

                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-walletlist>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <!-- {{ walletlist.academy[0].name }} -->
                    <div class="textOverFlow1" pTooltip="	{{walletlist.academy}}" tooltipPosition="bottom">
                      {{walletlist.academy}}
                    </div>
                  </td>

                  <td class="userNameTD">
                    {{ walletlist.createduserdata[0].fullName }}
                  </td>
                  <td class="userdateTD">
                    {{ walletlist.created_at | date : "dd/MM/yyyy" }}
                  </td>
                  <td class="amountTD">
                    {{ walletlist.transferAmount | currency : "INR" }}
                  </td>
                  <!-- <td class="">
                                    {{ walletlist.tds | currency : "INR" }}
                                </td> -->
                  <!-- <td class="">
                      {{ walletlist.commission | currency : "INR" }}
                    </td>-->
                  <td class="transferCreditTD">
                    {{ walletlist.totalCreditedAmount | currency : "INR" }}
                  </td>
                  <!-- <td 	[ngClass]="hide ? 'hide-col text-nowrap  ' : 'show-col text-nowrap '"></td> -->
                  <td class="BankDteailsTD">
                    {{ walletlist?.kycData[0]?.bankName }}
                  </td>
                  <!-- <td [ngClass]="hide ? 'hide-col text-nowrap  ' : 'show-col text-nowrap '"></td> -->
                  <td class="accountTD">
                    {{ walletlist?.kycData[0]?.accountNumber }}
                  </td>
                  <td class="status-Td statusTd" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <p-tag [ngClass]="getClassOf(walletlist.status)" value=" {{ walletlist.status }}"
                      [rounded]="true"></p-tag>
                    <!-- {{ walletlist.status }} -->
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                    <div class="status-button" *ngIf="walletlist.status == 'Pending'">
                      <ul>
                        <li>
                          <button class="approveBtn" (click)="showPaymentmodal(walletlist.id,walletlist)"
                            pTooltip="Approved " tooltipPosition="bottom">
                            <img src="../../../assets/images/backend-image/common-images/approveBtn.svg" alt="">
                          </button>
                          <button class="rejectBtn" (click)="showPaymentrejectmodal(walletlist.id,walletlist)"
                            pTooltip="Reject" tooltipPosition="bottom">
                            <img src="../../../assets/images/backend-image/common-images/reject--Btn.svg" alt="">
                          </button>
                        </li>
                      </ul>

                      <!-- <p-button class="approvebtn btn btn-success" (click)="showPaymentmodal(walletlist.id,walletlist)" icon="pi pi-check"> </p-button> -->
                      <!-- <button class="btn btn-success" (click)="approveuser(walletlist._id, walletlist)"> Approve </button> -->
                      <!-- <button class="btn btn-danger" (click)="rejectuser(walletlist._id, walletlist)"> Reject </button> -->
                      <!-- <p-button class="rejectbtn btn btn-danger" (click)="showPaymentrejectmodal(walletlist.id,walletlist)" icon="pi pi-times"></p-button> -->
                    </div>
                    <div class="status-buttons" *ngIf="walletlist.status == 'Approved'">
                      <button class="btn viewbtn" (click)="showPaymentmodal(walletlist.id,'view')"> View Details
                      </button>
                    </div>
                    <div class="status-buttons" *ngIf="walletlist.status == 'Rejected'">
                      <button class="btn reasonbtn" (click)="showPaymentrejectmodal(walletlist.id,'view')"><i
                          class="pi pi-question-circle"></i></button>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">Redemption request list not found.</td>
                </tr>
              </ng-template>
              <!-- <ng-template pTemplate="summary">
                  <div class="p-d-flex p-ai-center p-jc-between"> In total there are {{ totalRecords }} Redemption Requests. </div>
                </ng-template> -->
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>

<p-dialog header="Payment Approve" id="approveRejectModal" [(visible)]="paymentType" [modal]="true"
  [style]="{ width: '400px' }" [draggable]="false" [resizable]="false" class="modal-payment-select"
  (onHide)="onPaymentmodalModalClose()">
  <form [formGroup]="approveUpdateForm">
    <div class="p-grid">
      <div class="col-12 mb-3">
        <label for="comment"> Select Payment Method </label>
        <div class="form-div">
          <p-dropdown formControlName="paymentMethod" [options]="methods" [(ngModel)]="selectedMethod"
            optionLabel="name" appendTo="body" [filter]="true"></p-dropdown>
        </div>
      </div>
      <div class="col-12 mb-3">
        <label for="" *ngIf="dataPresent"> Add Payment Image </label>
        <label for="" *ngIf="!dataPresent"> Payment Image </label>
        <div class="form-div" *ngIf="dataPresent">
          <p-fileUpload name="myfiles[]" cancelLabel="Cancel" accept="image/*" maxFileSize="1000000" auto="auto"
            customUpload="true" (uploadHandler)="picUploader($event)" (onRemove)="removeFile($event)"></p-fileUpload>
        </div>
        <div *ngIf="showProfile">
          <div class="pan-image" (click)="openHightlightImage();">
            <img src="{{imageProfile}}" [alt]="loading" width="300" class="shadow-4" />
          </div>
          <div class="button-div" (click)="openHightlightImage();">
            <button pButton pRipple type="button" icon="pi pi-eye" class="p-button-rounded"></button>
            <p>View Image</p>
          </div>
        </div>
      </div>
      <div class="col-12 mb-3">
        <label for="comment"> Comment </label>
        <div class="form-div">
          <textarea inputId="textarea" pInputTextarea rows="4" class="form-control"
            formControlName="comment"></textarea>
        </div>
      </div>
      <div class="col-12 footer-forms">
        <button class="btn cancel-btn" (click)="onPaymentmodalModalClose()"> Cancel </button>
        <button class="btn rejectBtn" *ngIf="dataPresent" (click)="approveuser()"> Approve </button>
      </div>
    </div>
  </form>
</p-dialog>
<p-dialog header="Payment Reject" id="rejectModal" [(visible)]="paymentReject" [modal]="true"
  [style]="{ width: '400px' }" [draggable]="false" [resizable]="false" class="modal-payment-select payment_reject"
  (onHide)="onPaymentmodalModalClose()">
  <form [formGroup]="rejectUpdateForm">
    <div class="p-grid">
      <div class="col-12">
        <label for="comment"> Add Reason <span class="mandatory-fields ">*</span>
        </label>
        <div class="form-div">
          <textarea pInputTextarea rows="5" formControlName="comment"></textarea>
        </div>
      </div>
      <div class="col-12 footer-forms">
        <button class="btn cancel-btn" (click)="onPaymentmodalModalClose()"> Cancel </button>
        <button class="btn rejectBtn" *ngIf="dataPresent" (click)="rejectuser()" type="submit"> Reject </button>
      </div>
    </div>
  </form>
</p-dialog>
<p-galleria [(value)]="walletlist" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
  [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
  [showItemNavigators]="false" [showThumbnails]="false">
  <ng-template pTemplate="item" let-walletlist>
    <img [src]=showHighlightImg [alt]="" style="width: 100%; display: block;" />
  </ng-template>
</p-galleria>